module.exports = __webpack_public_path__ + "img/galaxy.e2e52c41.jpg";